// extracted by mini-css-extract-plugin
export default {"queryContainer":"ReleaseHistoryPage_queryContainer__XmcPT"};